import PropTypes from "prop-types";
import Links from "./Links";
import styles from "./MainContent.css";
import MyAccountLinks from "../MyAccountLinks";
import SocialLinks from "./SocialLinks";
import PaymentOptions from "./PaymentOptions";
import Greeter from "../Greeter";
import AppDownload from "../AppDownload";
import { SMALL_VIEWPORT } from "../../state/modules/layout";
import withViewport from "../Viewport/withViewport";
import classnames from "classnames";
import { useEffect, useState } from "react";
import { getLoyaltyStatus } from "@template/state/modules/loyalty";
import { useSelector } from "react-redux";
import { isLoggedIn } from "../../state/modules/user";

const MainContent = ({ items, isAccordion }) => {
  const { optedIn, isAvailable } = useSelector(getLoyaltyStatus);
  const authenticated = useSelector(state => isLoggedIn(state));
  const [showMyAccountNotification, setShowMyAccountNotification] =
    useState(false);

  useEffect(() => {
    if (authenticated && isAvailable && !optedIn) {
      const clearNotificationWaiting =
        localStorage && localStorage.getItem("clearNotificationWaiting");
      setShowMyAccountNotification(!clearNotificationWaiting);
    }
  }, [optedIn, authenticated, isAvailable]);

  useEffect(() => {
    if (optedIn) {
      localStorage.removeItem("clearNotificationWaiting");
      setShowMyAccountNotification(false);
    }
  }, [optedIn]);

  return (
    <div
      className={classnames({
        [styles.pageFooter]: !isAccordion
      })}
    >
      <div className={styles.iconBar}>
        <SocialLinks />
        <PaymentOptions />
      </div>
      <div className={styles.greeterWrapper}>
        <Greeter viewable={[SMALL_VIEWPORT]} />
      </div>
      <MyAccountLinks
        viewable={[SMALL_VIEWPORT]}
        queryParams={{ nlid: "nav footer" }}
        showMyAccountNotification={showMyAccountNotification}
      />
      <div
        className={classnames({
          [styles.footerLinksContainer]: true,
          [styles.accordionFooterLinksContainer]: isAccordion
        })}
      >
        <AppDownload
          isAccordion={isAccordion}
          ctaRef={
            isAccordion
              ? "sideNavigation footer|appDownload component|our apps"
              : "global footer|appDownload component|our apps"
          }
        />
        <Links items={items} isAccordion={isAccordion} />
      </div>
    </div>
  );
};

MainContent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  isAccordion: PropTypes.bool.isRequired
};

export default withViewport(MainContent);
